import { STATUSPAGE } from '@repo/ui';
import { ChangePasswordProfileUseCaseInterface } from 'domain/usecases';
import { FormikProps } from 'formik';
import { CardBody } from 'reactstrap';

import { ModalChangePassword } from '../../modalChangePassword';

interface IProps {
  isModalOpen: boolean;
  handleToggleModal: () => void;
  requestChangePasswordProfile: (
    params: ChangePasswordProfileUseCaseInterface.Params,
  ) => void;
  clearModalAndClose: () => void;
  validationModalChangePassword: FormikProps<ChangePasswordProfileUseCaseInterface.Params>;
  loadingModalChangePassword: STATUSPAGE;
}

export const Security = ({
  handleToggleModal,
  clearModalAndClose,
  requestChangePasswordProfile,
  isModalOpen,
  loadingModalChangePassword,
  validationModalChangePassword,
}: IProps) => {
  return (
    <>
      <ModalChangePassword
        isOpen={isModalOpen}
        toggleModal={handleToggleModal}
        clearModalAndClose={clearModalAndClose}
        loadingModalChangePassword={loadingModalChangePassword}
        requestChangePasswordProfile={requestChangePasswordProfile}
        validationModalChangePassword={validationModalChangePassword}
      />
      <CardBody className="p-4">
        <div
          className="d-flex justify-content-between align-items-center cursor-pointer border-bottom pb-3"
          onClick={handleToggleModal}
        >
          <div>
            <span className="fw-bold">Definir nova senha</span>
            <p className="text-muted mb-0">
              Altere sua senha de forma rápida e segura para proteger sua conta.
            </p>
          </div>
          <div>
            <i className="ri-arrow-right-line fs-4 text-muted"></i>
          </div>
        </div>
      </CardBody>
    </>
  );
};
